const fr = {
    actionAlready: "Pas encore inscrit ? Connectez-vous",
    actionExit: "Déconnexion",
    actionLogin: "CONNEXION",
    actionRegister: "INSCRIPTION",
    actionSave: "ENREGISTRER",
    actionStart: "COMMENCER",
    actionContinue: "CONTINUER",
    actionReset: "RÉINITIALISER L'ÉVALUATION",
    actionDoDiagnost: "AFFICHER LE DIAGNOSTIC",
    actionYes: "Oui",
    actionNo: "Non",
    actionNext: "SUIVANT",
    actionBusinessCase: "AFFICHER LA BONNE PRATIQUE DE L'ENTREPRISE",
    actionBusinessCases: "AFFICHER LES BONNES PRATIQUES DES ENTREPRISES",
    actionOpenUrl: "OUVRIR L'URL",
    actionFilter: "FILTRER",

    /** HOME */
    msgHomeTitleOne: "Mesurez et améliorez le niveau de maturité circulaire de votre entreprise de mobilier",
    msgHomeSubTitle: "L'outil en ligne FurnCIRCLE évalue la progression de votre entreprise vers la maturité circulaire en fonction des stratégies de conception circulaire mises en œuvre",

    msgHomeSection2: "Les exigences en matière de circularité se multiplient.</br>Êtes-vous prêt ?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Répondez aux questions sur les stratégies de conception circulaire actuellement mises en œuvre dans votre entreprise.</li><li>Obtenez l'indice de maturité circulaire de votre entreprise.</li><li>Identifiez les stratégies de conception et les bonnes pratiques des entreprises pour faire progresser votre entreprise.</li><li>Apprenez des bonnes pratiques d'entreprises réelles pour continuer à améliorer le niveau de maturité circulaire de votre entreprise.</li></ul>",
    msgHomeSection3: "Partenaires",
    msgHomeSection2Btn: "Commencez votre évaluation",
    msgHomeSection3Btn: "CONTACT",

    /** HEADER */
    msgHeader1: "Stratégies de conception circulaire et bonnes pratiques",
    msgHeader4: "Connexion",

    /** DRAWER */
    msgCompany: "ENTREPRISE",
    msgDrawer1: "1. Répondre",
    msgDrawer2: "2. Évaluer",
    msgDrawer3: "3. Améliorer",
    msgDrawer4: "Collection de stratégies",
    msgDrawer6: "Paramètres",
    msgDrawer7: "Déconnexion",

    /** LOGIN */
    msgWelcome: "Bienvenue",
    msgWelcomeSubtitle: "Veuillez vous connecter pour continuer",

    /** REGISTER */
    msgGetStarted: "Commencer",
    msgGetStartedSubtitle: "Cet outil d'auto-évaluation est gratuit et confidentiel",

    msgFirstname: "Prénom",
    msgLastname: "Nom",
    msgEmail: "Email",
    msgPassword: "Mot de passe",
    msgConfirmPassword: "Confirmez le mot de passe",
    msgCompanyUser: "Entreprise ou nom d'utilisateur",

    msgNotRegister: "Pas encore inscrit ? <b>Créez un compte ici</b>",
    msgAlreadyRegister: "Déjà inscrit ? <b>Connectez-vous ici</b>",

    /** HOME TOOL */
    msgClickImage: "Cliquez pour agrandir le système de modèle linéaire versus circulaire.",

    msgArea: "ZONE",
    msgProgress: "QUESTIONS RÉPONDUES",

    msgAssessmentAreas: "Stratégies de conception circulaire et cycle de vie du produit",
    msgAssessmentDesc: "Les stratégies de conception circulaire sont appliquées lors de la phase de conception et de développement des produits, bien que leur impact (positif) puisse se produire à une ou plusieurs étapes ultérieures du cycle de vie du produit. Ainsi, une façon de classer les stratégies de conception circulaire est selon l'étape du cycle de vie impactée : conception, ressources matérielles, production, distribution, utilisation et fin de vie.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Veuillez répondre à toutes les questions pour chaque bloc ou phase du cycle de vie, déterminez votre niveau de maturité circulaire et planifiez votre amélioration et votre transition vers une économie plus circulaire !</span>",

    msgAssessment: "Évaluation FurnCIRCLE",
    msgNotApply: "Cochez toutes les réponses qui s’appliquent à la performance circulaire actuelle de votre entreprise. Les réponses sont enregistrées automatiquement.",
    msgMarkImportant: "Marquer comme important",
    msgComment: "Commentaire",
    msgCommentHolder: "Vous pouvez écrire ici toute information pertinente ou vos propres commentaires.",

    /** ANSWER */
    msgPerformance: "Rapport d'évaluation",
    msgPerformanceSubtitle: "Découvrez l'indice de maturité circulaire de votre entreprise et de chaque phase du cycle de vie de vos produits.",
    msgCompanyLevel: "Indice de maturité circulaire de votre entreprise (0%-100%)",
    msgBlockArea: "PHASE DU CYCLE DE VIE",
    msgBlockValues: "VALEURS",

    /** ASSESS */
    msgImprovement: "Rapport d'amélioration",
    msgImprovementMainSubtitle: "Découvrez ce que vous pouvez faire pour améliorer en continu la circularité de votre entreprise. Connaissez les stratégies de conception et les bonnes pratiques des entreprises pour faire progresser votre entreprise.</br></br>Les phases du cycle de vie et les stratégies de conception circulaire avec une étiquette/cercle “rouge” ont un niveau de performance inférieur ou égal à 25 % de leur valeur maximale et peuvent donc être considérées comme une priorité pour améliorer la circularité de l'entreprise. Les phases ou stratégies avec une étiquette/cercle “orange” ont un niveau de performance supérieur à 25 % et inférieur ou égal à 75 %, il est donc également important d'améliorer ces aspects. Les phases ou stratégies avec une étiquette/cercle “vert” ont un niveau de performance supérieur à 75 % et sont donc une priorité moindre pour l'amélioration.",
    msgImprovementSubtitle: "Découvrez ce que vous pouvez faire pour améliorer en continu la circularité de votre entreprise. Connaissez les stratégies de conception et les bonnes pratiques des entreprises pour faire progresser votre entreprise.",
    msgLifecyclePhases: "Phases du cycle de vie",
    msgLifecycleIndex: "Indice de circularité de la phase",
    msgActionsToImplement: "Actions à mettre en œuvre :",
    msgBaselineScore: "Mon score de référence",
    msgBusinessCaseEmpty: "Félicitations ! Vous avez déjà mis en œuvre les principales stratégies de cette catégorie.",

    msgCat1: "ÉCONOMIQUE ET ORGANISATIONNEL",
    msgCat2: "SOCIÉTAL",
    msgCat3: "ENVIRONNEMENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Parcourez et explorez la collection complète des stratégies de conception circulaire et des bonnes pratiques des entreprises du projet FurnCIRCLE.",
    msgLifecyclePhase: "Phase du cycle de vie",
    msgDifficulty: "Difficulté de mise en œuvre",
    msgBusinessDynamics: "Génération ou livraison de valeur",
    msgBusinessFactors: "Proposition de valeur / Coûts / Bénéfices",

    /** SETTINGS */
    msgUserInfo: "Informations de l'utilisateur",
    msgUserCredentials: "Identifiants de l'utilisateur",

    /** MODAL */
    msgAreSure: "Êtes-vous sûr ?",

    msgSuccess: "Mise à jour des données réussie",
    msgDeleteSuccess: "Suppression des données réussie",

    msgSaveCommentAlt: "Enregistrez le “Commentaire”. Il n’est pas nécessaire d’enregistrer les réponses aux questions ; elles sont enregistrées automatiquement.",
    msgDifficultyAlt: "Cette étiquette indique la difficulté de mise en œuvre de la stratégie de conception circulaire.",
    msgBusinessBlockAlt: "Cette étiquette indique quel bloc commercial du modèle CANVAS (Génération de Valeur ou Livraison de Valeur) est affecté par la mise en œuvre de la stratégie de conception circulaire.",
    msgImpactBlockAlt: "Cette étiquette indique quel bloc d’impact du modèle CANVAS (Coûts, Bénéfices ou Proposition de Valeur) est affecté par la mise en œuvre de la stratégie de conception circulaire.",

    /** ERROR */
    errorOblData: "Remplissez tous les champs obligatoires",
    errorEmailFormat: "Erreur de format d'email",
    errorUserIncorrect: "Email/mot de passe incorrect",
    errorSend: "Erreur de communication, veuillez patienter et réessayer plus tard",
    errorLength: "Le nombre de caractères a été dépassé",
    errorPassSame: "Les mots de passe ne sont pas identiques",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Récupération du mot de passe",
    msgRecoveryPasswordSubtitle: "Veuillez saisir votre adresse e-mail pour recevoir un code de réinitialisation du mot de passe.",
    msgCode: "Code",
    msgNewPassword: "Nouveau mot de passe",
    actionRequestCode: "DEMANDER LE CODE",
    actionUpdate: "METTRE À JOUR",
    actionBack: "RETOUR",
    msgForgetPassword: "Mot de passe oublié ?",
    errorRecovery: "Erreur de récupération du mot de passe, veuillez vérifier le code fourni",

    /** FOOTER */
    msgFooterContact: "CONTACT",

    msgFooterGr: "Financé par l'Union européenne. Les opinions exprimées sont celles des auteurs uniquement et ne reflètent pas nécessairement celles de l'Union européenne. Ni l'Union européenne ni l'autorité de financement ne peuvent être tenues responsables de ces opinions. Référence de l’appel et de l'accord de subvention : SOCPL-2022-SOC-DIALOG-01 (Projet 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Tous droits réservés",

    msgFooterLegal: "Mentions légales",
    msgFooterPrivacy: "Confidentialité",
    msgFooterCookies: "Politique de cookies",

    /** PROGRESS VALUES */
    msgProgress0: "Stratégies de conception circulaire",

    /** COMPANY SIZES */
    msgCompanySize: "Taille de l'entreprise",
    msgCompanySize1: "Moins de 10 employés",
    msgCompanySize2: "10-30 employés",
    msgCompanySize3: "30-50 employés",
    msgCompanySize4: "Plus de 50 employés",

    /** PRODUCT TYPES */
    msgProductType: "Type de produits que vous fabriquez",
    msgProductType1: "Rembourrage",
    msgProductType2: "Matelas",
    msgProductType3: "Bases rembourrées, canapés, sommiers",
    msgProductType4: "Sous-traitant (cadres, usinage, vernissage, etc.)",
    msgProductType5: "Services (logistique spécialisée, etc.)",
    msgProductType6: "Meubles en panneaux (mélaminé, placage, laque, etc.)",
    msgProductType7: "Meubles en bois",
    msgProductType8: "Chaises",
    msgProductType9: "Mobilier de bureau",
    msgProductType10: "Mobilier pour espaces et usages publics",
    msgProductType11: "Portes, fenêtres et produits de menuiserie",
    msgProductType12: "Installations sur mesure (magasins, bibliothèques, restaurants, commerces professionnels, etc.)",
    msgProductType13: "Éclairage",
    msgProductType14: "Revêtements et sols",
    msgProductType15: "Textile",
    msgProductType16: "Décorations",

    /* COUNTRIES */
    msgCountry: "Pays",
    msgAfghanistan: "Afghanistan",
    msgAlbania: "Albanie",
    msgAlgeria: "Algérie",
    msgAmericanSamoa: "Samoa américaines",
    msgAndorra: "Andorre",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarctique",
    msgAntiguaandBarbuda: "Antigua-et-Barbuda",
    msgArgentina: "Argentine",
    msgArmenia: "Arménie",
    msgAruba: "Aruba",
    msgAustralia: "Australie",
    msgAustria: "Autriche",
    msgAzerbaijan: "Azerbaïdjan",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahreïn",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbade",
    msgBelarus: "Biélorussie",
    msgBelgium: "Belgique",
    msgBelize: "Belize",
    msgBenin: "Bénin",
    msgBermuda: "Bermudes",
    msgBhutan: "Bhoutan",
    msgBolivia: "Bolivie",
    msgBosniaHerzegovina: "Bosnie-Herzégovine",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Île Bouvet",
    msgBrazil: "Brésil",
    msgBritishIndian: "Territoire britannique de l'océan Indien",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgarie",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Cambodge",
    msgCameroon: "Cameroun",
    msgCanada: "Canada",
    msgCapeVerde: "Cap-Vert",
    msgCaymanIslands: "Îles Caïmans",
    msgCentralAfrican: "République centrafricaine",
    msgChad: "Tchad",
    msgChile: "Chili",
    msgChina: "Chine",
    msgChristmasIsland: "Île Christmas",
    msgCocosIslands: "Îles Cocos (Keeling)",
    msgColombia: "Colombie",
    msgComoros: "Comores",
    msgCongo: "Congo",
    msgRepublicCongo: "République démocratique du Congo",
    msgCookIslands: "Îles Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Côte d'Ivoire",
    msgCroatia: "Croatie",
    msgCuba: "Cuba",
    msgCyprus: "Chypre",
    msgCzechRepublic: "République tchèque",
    msgDenmark: "Danemark",
    msgDjibouti: "Djibouti",
    msgDominica: "Dominique",
    msgDominicanRepublic: "République dominicaine",
    msgEastTimor: "Timor oriental",
    msgEcuador: "Équateur",
    msgEgypt: "Égypte",
    msgEngland: "Angleterre",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guinée équatoriale",
    msgEritrea: "Érythrée",
    msgEstonia: "Estonie",
    msgEthiopia: "Éthiopie",
    msgFalklandIslands: "Îles Malouines",
    msgFaroeIslands: "Îles Féroé",
    msgFijiIslands: "Îles Fidji",
    msgFinland: "Finlande",
    msgFrance: "France",
    msgFrenchGuiana: "Guyane française",
    msgFrenchPolynesia: "Polynésie française",
    msgFrenchSouthern: "Terres australes et antarctiques françaises",
    msgGabon: "Gabon",
    msgGambia: "Gambie",
    msgGeorgia: "Géorgie",
    msgGermany: "Allemagne",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grèce",
    msgGreenland: "Groenland",
    msgGrenada: "Grenade",
    msgGuadeloupe: "Guadeloupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernesey",
    msgGuinea: "Guinée",
    msgGuineaBissau: "Guinée-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haïti",
    msgHeardMcDonald: "Îles Heard-et-MacDonald",
    msgHolySee: "Saint-Siège (État de la Cité du Vatican)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Hongrie",
    msgIceland: "Islande",
    msgIndia: "Inde",
    msgIndonesia: "Indonésie",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irlande",
    msgIsrael: "Israël",
    msgIsleMan: "Île de Man",
    msgItaly: "Italie",
    msgJamaica: "Jamaïque",
    msgJapan: "Japon",
    msgJersey: "Jersey",
    msgJordan: "Jordanie",
    msgKazakhstan: "Kazakhstan",
    msgKenya: "Kenya",
    msgKiribati: "Kiribati",
    msgKuwait: "Koweït",
    msgKyrgyzstan: "Kirghizistan",
    msgLaos: "Laos",
    msgLatvia: "Lettonie",
    msgLebanon: "Liban",
    msgLesotho: "Lesotho",
    msgLiberia: "Libéria",
    msgLibyanJamahiriya: "Jamahiriya arabe libyenne",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituanie",
    msgLuxembourg: "Luxembourg",
    msgMacao: "Macao",
    msgNorthMacedonia: "Macédoine du Nord",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malaisie",
    msgMaldives: "Maldives",
    msgMali: "Mali",
    msgMalta: "Malte",
    msgMarshallIslands: "Îles Marshall",
    msgMartinique: "Martinique",
    msgMauritania: "Mauritanie",
    msgMauritius: "Maurice",
    msgMayotte: "Mayotte",
    msgMexico: "Mexique",
    msgMicronesia: "Micronésie, États fédérés de",
    msgMoldova: "Moldavie",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolie",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Monténégro",
    msgMorocco: "Maroc",
    msgMozambique: "Mozambique",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibie",
    msgNauru: "Nauru",
    msgNepal: "Népal",
    msgNetherlands: "Pays-Bas",
    msgNetherlandsAntilles: "Antilles néerlandaises",
    msgNewCaledonia: "Nouvelle-Calédonie",
    msgNewZealand: "Nouvelle-Zélande",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigéria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Île Norfolk",
    msgNorthKorea: "Corée du Nord",
    msgNorthernIreland: "Irlande du Nord",
    msgNorthernMariana: "Îles Mariannes du Nord",
    msgNorway: "Norvège",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palaos",
    msgPalestine: "Palestine",
    msgPanama: "Panama",
    msgPapua: "Papouasie-Nouvelle-Guinée",
    msgParaguay: "Paraguay",
    msgPeru: "Pérou",
    msgPhilippines: "Philippines",
    msgPitcairn: "Pitcairn",
    msgPoland: "Pologne",
    msgPortugal: "Portugal",
    msgPuertoRico: "Porto Rico",
    msgQatar: "Qatar",
    msgReunion: "Réunion",
    msgRomania: "Roumanie",
    msgRussianFederation: "Fédération de Russie",
    msgRwanda: "Rwanda",
    msgSaintHelena: "Sainte-Hélène",
    msgSaintKitts: "Saint-Christophe-et-Niévès",
    msgSaintLucia: "Sainte-Lucie",
    msgSaintPierre: "Saint-Pierre-et-Miquelon",
    msgSaintVincent: "Saint-Vincent-et-les-Grenadines",
    msgSamoa: "Samoa",
    msgSanMarino: "Saint-Marin",
    msgSaoTome: "Sao Tomé-et-Principe",
    msgSaudiArabia: "Arabie saoudite",
    msgScotland: "Écosse",
    msgSenegal: "Sénégal",
    msgSerbia: "Serbie",
    msgSeychelles: "Seychelles",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapour",
    msgSlovakia: "Slovaquie",
    msgSlovenia: "Slovénie",
    msgSolomonIslands: "Îles Salomon",
    msgSomalia: "Somalie",
    msgSouthAfrica: "Afrique du Sud",
    msgSouthSandwich: "Géorgie du Sud et îles Sandwich du Sud",
    msgSouthKorea: "Corée du Sud",
    msgSouthSudan: "Soudan du Sud",
    msgSpain: "Espagne",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Soudan",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard et Jan Mayen",
    msgSwaziland: "Eswatini",
    msgSweden: "Suède",
    msgSwitzerland: "Suisse",
    msgSyria: "Syrie",
    msgTajikistan: "Tadjikistan",
    msgTanzania: "Tanzanie",
    msgThailand: "Thaïlande",
    msgTimorLeste: "Timor oriental",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinité-et-Tobago",
    msgTunisia: "Tunisie",
    msgTurkey: "Turquie",
    msgTurkmenistan: "Turkménistan",
    msgTurksCaicos: "Îles Turques-et-Caïques",
    msgTuvalu: "Tuvalu",
    msgUganda: "Ouganda",
    msgUkraine: "Ukraine",
    msgUnitedArabEmirates: "Émirats arabes unis",
    msgUnitedKingdom: "Royaume-Uni",
    msgUnitedStates: "États-Unis",
    msgUnitedStatesMinor: "Îles mineures éloignées des États-Unis",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Ouzbékistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Viêt Nam",
    msgVirginIslandsBritish: "Îles Vierges britanniques",
    msgVirginIslandsUS: "Îles Vierges des États-Unis",
    msgWales: "Pays de Galles",
    msgWallisFutuna: "Wallis-et-Futuna",
    msgWesternSahara: "Sahara occidental",
    msgYemen: "Yémen",
    msgZambia: "Zambie",
    msgZimbabwe: "Zimbabwe",
}
export default fr;